export default __webpack_public_path__ + "static/media/vrujen.bcc38d1d.jpeg";